/* global requestAnimationFrame */
jQuery( () => {
	// Disabled for now, as it causes some layout shift in best case scenario and broken grids in worst case scenario when the results are loaded,
	// and there are no hooks in Elastic Search that are triggered after the results are rendered to do it properly.
	// initElasticSearchMasonry();
	
	const elasticSearchElement = document.querySelector( '.js-elastic-search' );
	const hideClass = 'is-hidden';

	wp.hooks.addFilter( 'qalaElasticFilters.filter.pagerScrollTo', 'AppPagerScrollToFilter', ( scrollTo ) => {
		// Scroll to the top of the results container instead of the top of the page
		const resultsContainer = document.querySelector('.qesf-container');
		if ( resultsContainer ) {
			const rect = resultsContainer.getBoundingClientRect();
			return { x: 0, y: window.scrollY + rect.top - 32 }; // Adjust -32 for some spacing
		}

		return scrollTo; // Default fallback
	} );

	if ( ! elasticSearchElement ) {
		return;
	}

	const elasticSearchLoader = elasticSearchElement.querySelector( '.js-elastic-search-loader' );
	const containerElement = elasticSearchElement.querySelector( '.js-qesf-search-page-header-has-results-container' );
	const paginationElement = elasticSearchElement.querySelector( '#qesf-pagination' );
	const resultsElement = elasticSearchElement.querySelector( '[data-name="qec-results"]' );
	const element404 = elasticSearchElement.querySelector( '.js-qesf-search-page-404' );
	let timeout = null;

	wp.hooks.addAction( 'qalaElasticCore.action.beforeQuery', 'QalaTheme', () => {
		if ( timeout ) {
			clearTimeout( timeout );
		}

		if ( ! elasticSearchLoader.classList.contains( hideClass ) ) {
			return;
		}

		elasticSearchLoader.classList.remove( hideClass );
	} );

	wp.hooks.addAction( 'qalaElasticCore.action.onResult.meta', 'QalaTheme', meta => {
		if ( timeout ) {
			clearTimeout( timeout );
		}

		if ( ! meta || ! meta.page ) {
			return;
		}

		timeout = setTimeout( () => {
			// Try to do everything in one go to minimize any jumping / popup.
			requestAnimationFrame( () => {
				if ( meta?.page?.total_pages === 0 ) {
					show404();
				} else {
					hide404();
				}

				if ( ! elasticSearchLoader.classList.contains( hideClass ) ) {
					elasticSearchLoader.classList.add( hideClass );
				}
			} );
		}, wp.hooks.applyFilters( 'qalaTheme.filter.elastic_search_loader_timeout', 50 ) );
	} );

	const show404 = () => {
		containerElement.classList.add( 'is-hidden' );
		element404.classList.remove( 'is-hidden' );

		paginationElement.style.display = 'none';
		resultsElement.style.display = 'none';
	};

	const hide404 = () => {
		containerElement.classList.remove( 'is-hidden' );
		element404.classList.add( 'is-hidden' );

		paginationElement.style.display = 'initial';
		resultsElement.style.display = 'initial';
	};
} );

/**
 * Init New Art Day specific Masonry for Elastic Search results.
 * Need to use a timeout to make sure the elements are rendered before initializing Masonry,
 * otherwise it will calculate wrong sizes and positions.
 * 
 * Might not be a optimal solution, it gives some layoutshift when the results are loaded,
 * but I did not find any hooks in Elastic Search that are triggered after the results are rendered.
 */
function initElasticSearchMasonry() {
	const initMasonry = () => {
		const grid = document.querySelector( '.grid-masonry' );

		if ( ! grid ) {
			return;
		}

		new Masonry( grid, {
			percentPosition: true,
		} );
	}

	setTimeout(() => {
		initMasonry();
	}, 100);

	wp.hooks.addAction( 'qalaElasticCore.action.onResult.results', 'newArtDay', () => {
		setTimeout(() => {
			initMasonry();
		}, 500);
	}, 999);

	window.addEventListener( 'resize', () => {
		initMasonry();
	});
}